/* eslint-disable no-unused-expressions */
/* eslint-disable array-callback-return */
/* eslint-disable no-mixed-operators */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable max-len */
/* eslint-disable import/extensions */
import { END } from "redux-saga";
import { loadSelf } from "@fdn/profile_store";
import Env from "Consts/env";
import cookie from "cookie";
// import Layout from "Containers/layout";
import Breadcrumb from "@fdn/breadcrumb";
import { IconShoppingCart, IconCreditCard } from "@tabler/icons";
import dynamic from "next/dynamic";
import { wrapper } from "@/Store/index";
import { loadCategoryDesktop } from "@/Store/category_desktop_store/lib/actions";

const Layout = dynamic(
	() => import("Containers/layout"),
	{ ssr: false },
);

const Faq = (props) => {

	const data = props;
	const { query: { device } } = data;

	return (
		<Layout
			home
			title="Femaledaily"
			metaTitle="FAQ"
			typeNavbarSecondary="type-1"
			titleNavbar="FAQ"
			ismobile={data.isMobile}
			self={data.getStoreSelf}
			categoryDesktop={data && data.storeCategoryDesktop}
			device={device}
			isShowSecondaryNav={false}
		>
			<div className={!data.isMobile ? "container" : ""}>
				{data?.isMobile && (device !== "1" && device !== "2") && (
					<Breadcrumb
						isHeader
						isMobile={data.isMobile}
						breadcrumbs={["faq"]}
						destinationUrl={`${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/faq`}
						margin={data.isMobile ? "20px 20px 0 20px" : "15px 0 30px 0"}
						textTransform="capitalize"
						fontFamily="Creato Display, sans-serif"
						color="#000"
						fontWeightActive="700"
					/>
				)}
				<div className={data.isMobile ? "content" : "content desktop"}>
					<p className="title-page">Frequently Asked Question</p>
					<ol className="parent">
						<p className="title">
							<IconShoppingCart />
							{" "}
							<span>Pesanan</span>
						</p>
						<li>
							<p>Apakah produk-produk di Female Daily Studio aman dan asli?</p>
							<ul className="child">
								Tak perlu ragu! Semua produk dikurasi dengan cermat oleh tim kami karena kami ingin kamu mendapatkan yang terbaik! Kami juga bekerjasama langsung dengan brand partner kami untuk memastikan semua produk yang dijual di Female Daily Studio terdaftar di Badan Pengawasan Obat dan Makanan (BPOM).
							</ul>
						</li>
						<li>
							<p>Bisakah saya membatalkan pesanan yang sudah saya bayar?</p>
							<ul className="child">
								Sayangnya, pesanan tidak dapat dibatalkan atau diubah setelah pembayaran terkonfirmasi.
							</ul>
						</li>
						<li>
							<p>Saya lupa kata sandi saya. Bagaimana cara meresetnya?</p>
							<ul className="child">
								Kamu dapat masuk ke HALAMAN SIGN IN, isi alamat email atau nomor telepon atau username, lalu klik “Forgot Password” di bawah. Kami akan mengirimkan email untuk mengubah kata sandi.
							</ul>
						</li>
						<li>
							<p>Di mana saya bisa melihat konfirmasi pesanan saya?</p>
							<ul className="child">
								Kami akan mengirimkan email konfirmasi pesanan termasuk ID pesananmu, atau kamu dapat memeriksa detail pesanan di halaman Akun Saya. Jika kamu tidak dapat menemukan email tersebut, silakan periksa folder spam :D
							</ul>
						</li>
						<li>
							<p>Saya mengalami masalah pemesanan. Di mana saya bisa mendapatkan bantuan?</p>
							<ul className="child">
								Silakan hubungi kami di help@femaledaily.com atau WHATSAPP (+6285772899179), tim kami siap membantu!
							</ul>
						</li>
					</ol>
					<ol className="parent">
						<p className="title">
							<IconCreditCard />
							{" "}
							<span>Pengiriman</span>
						</p>
						<li>
							<p>Berapa lama pembelian saya akan tiba?</p>
							<ul className="child">
								Setelah pesanan dikonfirmasi, tim kami akan segera meninjau dan memproses pesananmu. Kami akan mengirimkan pesanan pada hari yang sama jika pembayaran diterima sebelum pukul 17:00 WIB, setelah jam tersebut itu pesanan akan dikirimkan pada hari kerja berikutnya.
								<br />
								<br />
								Harap dicatat bahwa kami hanya memproses dan mengirimkan pesanan selama jam kerja dari Senin sampai Jumat. Semua pesanan yang diterima pada akhir pekan akan diproses pada hari Senin berikutnya, dan pesanan yang diterima pada hari libur nasional akan diproses pada hari kerja berikutnya. Pesanan biasanya akan memakan waktu 1-7 hari kerja sejak hari pengiriman hingga tiba di tujuan.
							</ul>
						</li>
						<li>
							<p>Bisakah saya melacak pembelian saya?</p>
							<ul className="child">
								Tentu saja! Setelah pesanan dikirim, pemberitahuan pengiriman termasuk informasi pelacakan akan dikirim melalui e-mail atau dapat dilihat di halaman Akun Saya.
							</ul>
						</li>
						<li>
							<p>Saya tidak di Indonesia. Apakah FD Studio melayani pengiriman internasional?</p>
							<ul className="child">
								Sayangnya, saat ini kami hanya mengirim ke tujuan di Indonesia.
							</ul>
						</li>
						<li>
							<p>Ada masalah dengan pengiriman pesanan saya. Di mana saya bisa mendapatkan bantuan?</p>
							<ul className="child">
								Silakan hubungi kami di help@femaledaily.com atau WHATSAPP (+6285772899179) agar kami dapat segera membantu!
							</ul>
						</li>
					</ol>
				</div>
				<style jsx>
					{`
						.content .title-page {
							font-weight: 600;
							font-style: normal;
							font-size: 24px;
							line-height: 32px;
							padding: ${data.isMobile ? "0 20px" : "0"};
						}
						.content.desktop .title-page {
							font-size: 36px;
							line-height: 36px;
						}
						.content ol.parent {
							margin: 0 30px 30px 0;
						}
						.content ol.parent p.title {
							font-weight: 600;
							font-style: normal;
							font-size: 16px;
							line-height: 16px;
							margin: 0 -20px;
							padding: 0;
							display: flex;
							align-items: center;

							max-width: 100%;
						}
						.content.desktop ol.parent p.title {
							font-size: 20px;
							line-height: 24px;
						}
						.content ol.parent p.title span {
							margin: 0 0 0 5px;
						}
						.content ol.parent li {
							font-weight: 600;
							font-style: normal;
							font-size: 16px;
							line-height: 18px;
						}
						.content ol.parent li ul.child {
							margin: 0;
							padding: 0;
							font-weight: 400;
							font-style: normal;
							font-size: 14px;
							line-height: 22px;

							text-wrap: balance;
						}
					`}
				</style>
			</div>
		</Layout>
	);

};

export const getServerSideProps = wrapper.getServerSideProps(
	async ({ store, req, query }) => {

		let userAgent;
		let cookies;
		let authorization = null;

		if (req) {

			// if you are on the server and you get a "req" property from your context
			userAgent = req.headers["user-agent"]; // get the user-agent from the headers

		} else {

			// if you are on the client you can access the navigator from the window object
			userAgent = navigator.userAgent;

		}

		const isMobile = Boolean(
			userAgent.match(
				/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i,
			),
		);

		const isServer = !!req;

		if (req.headers.cookie) {

			cookies = cookie.parse(req.headers.cookie);
			authorization = cookies.token;

		}

		if (authorization) {

			await store.dispatch(
				loadSelf({
					payload: {
						api_env: process.env.NEXT_PUBLIC_NODE_ENV,
						env: Env.HEADERS,
						Authorization: authorization,
						is_server: isServer,
						is_allo: process.env.NEXT_PUBLIC_ALLO_STATUS === "ON",
					},
				}),
			);

		}

		await store.dispatch(
			loadCategoryDesktop({
				payload: {
				},
			}),
		);

		store.dispatch(END);
		await store.sagaTask.toPromise();

		const categoryNavigationDesktop = [];
		const brands = {
			id: 200,
			name: "Brands",
			slug: "brands",
			items: [],
		};

		const getStoreSelf = store.getState().storeSelf && typeof store.getState().storeSelf.data !== "undefined"
			? store.getState().storeSelf
			: null;

		const getStoreCategoryDesktop = store.getState().storeCategoryDesktop.data && typeof store.getState().storeCategoryDesktop.data.data !== "undefined"
			? store.getState().storeCategoryDesktop.data
			: null;

		getStoreCategoryDesktop
		&& getStoreCategoryDesktop.data[0]
		&& getStoreCategoryDesktop.data[0].children_data
		&& getStoreCategoryDesktop.data[0].children_data.filter((val) => val.include_in_menu === "1").map((item) => {

			categoryNavigationDesktop.push({
				id: item.entity_id,
				name: item.category_name,
				slug: item.category_path,
				items: item.children_data.length > 0
					? item.children_data.map((child) => ({
						id: child.entity_id,
						name: child.category_name,
						slug: child.category_path,
						items: child.children_data.length > 0
							? child.children_data.map((childs) => ({
								id: childs.entity_id,
								name: childs.category_name,
								slug: childs.category_path,
								items: childs.children_data.length > 0
									? childs.children_data.map((lastChilds) => ({
										id: lastChilds.entity_id,
										name: lastChilds.category_name,
										slug: lastChilds.category_path,
									})) : [],
							})) : [],
					})) : [],
			});

		});
		categoryNavigationDesktop.splice(1, 0, brands);

		return {
			props: {
				query,
				isMobile,
				getStoreSelf,
				storeCategoryDesktop: categoryNavigationDesktop || null,
			}, // will be passed to the page component as props
		};

	},
);

export default Faq;
